import {
  HISTORY_CONTEXT,
  HOME_CONTEXT,
  LOOMS_CONTEXT,
  PROFILE_CONTEXT,
  SHARE_CONTEXT,
  TAG_CONTEXT,
} from 'constants/videoCard';

export type Folder = {
  __typename: 'RegularUserFolder';
  type: string;
  id: string;
  isArchived: boolean;
  currentUserCanEdit: boolean;
  isTopLevelFolder: boolean;
  name: string;
  organization_id?: number;
  owner_id: number;
  shared: boolean;
  special_id: string | null;
  visibility: string;
};

export type Video = {
  __typename: 'RegularUserVideo';
  type: string;
  id: string;
  archived: boolean;
  current_user_is_owner: boolean;
  currentUserCanEdit: boolean;
  download_enabled: boolean;
  name: string;
  owner_id: number;
  visibility: string;
  privacy: string;
  organization_id?: number;
};

export type Item = Folder | Video;

export type User = {
  id: number;
  role: string;
};

export type Workspace = {
  id: string;
};

export type Dispatch = React.Dispatch<unknown>;

export interface Extras {
  shouldShowDownloadInfoModal: boolean;
  downloadUrl?: string;
}

export type ContextType =
  | typeof LOOMS_CONTEXT
  | typeof HISTORY_CONTEXT
  | typeof PROFILE_CONTEXT
  | typeof SHARE_CONTEXT
  | typeof TAG_CONTEXT
  | typeof HOME_CONTEXT;

export type MenuContext = {
  type?: ContextType;
  downloadUrl?: string;
};
export interface OnClickParameters {
  dispatch: Dispatch;
  items: Item[];
  extras: Extras;
  menuContext: MenuContext;
}

export interface ShowParameters {
  items: Item[];
  scopes: {
    hasArchiveAccessScope: boolean;
    hasAuthenticatedAccess: boolean;
    hasTeamLibraryWriteScope: boolean;
    hasVideoToolsAccessScope: boolean;
    hasVideoPublishAccessScope: boolean;
    hasVideoSharePrivateScope: boolean;
  };
  currentUser: User;
  selectedWorkspace: Workspace;
  menuContext: MenuContext;
}

export interface ItemContext {
  downloadUrl?: string;
}

export type MenuOption = {
  key: string;
  label: string;
  icon: JSX.Element;
  onClick: (parameters: OnClickParameters) => void;
  show: (paramaters: ShowParameters) => boolean;
};

export const REGULAR_USER_FOLDER = 'RegularUserFolder';
export const REGULAR_USER_VIDEO = 'RegularUserVideo';
